import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FamilyMember as FamilyMemberStore } from 'store/familyStore';
import RemoveButton from 'modules/family/components/family-member-table/remove-button';

class FamilyMember extends Component {
    render() {
        const { member } = this.props;
        const isOwner = member.user.id === member.family.owner.id;

        return (
            <tr>
                <td>{member.user.email}</td>
                <td className="text-right">
                    {!isOwner && <RemoveButton familyMember={member} />}
                </td>
            </tr>
        );
    }
}

FamilyMember.propTypes = {
    member: PropTypes.instanceOf(FamilyMemberStore).isRequired,
};

export default FamilyMember;


// WEBPACK FOOTER //
// ./src/modules/family/components/family-member-table/family-member.js